import { ExtensionSettingEnum } from '@colonist/game-base-types';
import { BASE_GAME_SPEED_SETTINGS } from './GameTimerOptionData.ts';
export class BaseGameModeData {
    isGameModePremium() {
        if (this.premiumExpansionAccess.length == 0) return false;
        return true;
    }
    getAllowablePlayerCount() {
        switch(this.extensionSetting){
            case ExtensionSettingEnum.Players4:
                return [
                    1,
                    2,
                    3,
                    4
                ];
            case ExtensionSettingEnum.Players56:
                return [
                    5,
                    6
                ];
            case ExtensionSettingEnum.Players78:
                return [
                    7,
                    8
                ];
        }
    }
    getNewInstanceOfData() {
        /* eslint-disable @typescript-eslint/prefer-function-type */ const newInstance = new this.constructor();
        return newInstance;
    }
    constructor(){
        this.defaultCardDiscardLimit = 7;
        this.defaultFriendlyRobber = false;
        this.minimumPlayerCount = 2;
        this.allowedGameTimers = BASE_GAME_SPEED_SETTINGS;
    }
}
